/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, Text } from 'theme-ui'

import { CardBoxStyled, CardBoxIconStyled, CardBoxTitleStyled, CardBoxDescStyled } from './styles'
import StaticImage from './../../atoms/ImageStatic'
import { CardBoxProps } from './types'

const CardBox: React.FC<CardBoxProps> = ({ title, desc, image }) => {
  return (
    <CardBoxStyled>
      {image && (
        <CardBoxIconStyled>
          <StaticImage {...{ image }} />
        </CardBoxIconStyled>
      )}

      {title && (
        <CardBoxTitleStyled>
          <Text
            as="p"
            sx={{
              variant: 'bodyRaleway1',
              fontFamily: 'secondary',
              textAlign: 'center',
              fontWeight: 'bold'
            }}
          >
            {title}
          </Text>
        </CardBoxTitleStyled>
      )}
      {desc && (
        <CardBoxDescStyled>
          <Text
            sx={{
              variant: 'bodyMontserrat2',
              fontFamily: 'primary',
              textAlign: 'center',
              opacity: '0.5'
            }}
            as="p"
          >
            {desc}
          </Text>
        </CardBoxDescStyled>
      )}
    </CardBoxStyled>
  )
}

export default CardBox
